module.exports = __webpack_public_path__ + "img/cooperate_yh_04@2x.1aa0f4f2.png";